<template>
    <v-dialog v-model="$store.state.invoice.excel" min-width="1360px">
        <v-card>
            <v-toolbar dark color="secondary" dense>
                <v-spacer />
                <v-toolbar-title class="white--text">KAG</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    dark
                    icon
                    left
                    @click="$store.state.invoice.excel = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-data-table
                    :headers="headers"
                    :items="excel"
                    height="600px"
                    :fixed-header="true"
                    dense
                    disable-pagination
                    hide-default-footer
                >
                </v-data-table>
                <v-row>
                    <v-col cols="12">
                        <v-btn
                            color="primary"
                            @click="getCreateKagInvoices()"
                            class="float-right ml-12"
                            >Save</v-btn
                        >
                        <v-btn
                            color="success"
                            @click="getTransactionKagInvoicesExcel()"
                            class="float-right"
                            ><v-icon>mdi-microsoft-excel</v-icon>
                            Download</v-btn
                        >
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    props: ['data', 'Kms', 'FSC', 'StartDate', 'EndDate', 'totals', 'invIds'],
    data: function() {
        return {
            excel: [],
            headers: [
                { text: 'Date', value: 'Date' },
                { text: 'Station', value: 'Station' },
                { text: 'Terminal', value: 'Terminal' },
                { text: 'BillOfLading', value: 'BillOfLading' },
                { text: 'EREG', value: 'EREG' },
                { text: 'PREM', value: 'PREM' },
                { text: 'Diesel', value: 'Diesel' },
                { text: 'MOQ', value: 'MOQ' },
                { text: 'GasRate', value: 'GasRate' },
                { text: 'Amount', value: 'Amount' },
                { text: 'Kms', value: 'Kms' },
                { text: 'FSC', value: 'FSC' },
                { text: 'Split', value: 'Split' },
                { text: 'Demurrage', value: 'Demurrage' },
                { text: 'HST', value: 'HST' },
                { text: 'Total', value: 'Total' },
                { text: 'OrderNumber', value: 'OrderNumber' },
                { text: 'InvId', value: 'InvId' }
            ]
        };
    },
    async mounted() {
        this.excel = this.data;
        console.log(this.totals);
        // this.relStationTerminal();
    },

    methods: {
        getCreateKagInvoices: function() {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                totals: this.totals,
                data: this.excel,
                invIds: this.invIds,
                StartDate: this.StartDate,
                EndDate: this.EndDate
            };
            axios
                .post('invoice/kms/create', parms)
                .then(async response => {
                    console.log(response.data);
                    str.state.isLoading = false;
                    str.state.invoice.excel = false;
                    this.$store.state.invoiceKms.search =
                        response.data.InvIdKms;
                    this.$router.push('/administration/invoice-search');
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },

        getTransactionKagInvoicesExcel: async function() {
            var str = this.$store;
            var parms = {
                StartDate: this.StartDate,
                EndDate: this.EndDate,
                FSC: this.FSC,
                Kms: this.Kms,
                Export: 1
            };
            str.state.isLoading = true;
            axios
                .post('invoice/kms/show', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Excel-KAG.xlsx');
                    document.body.appendChild(link);
                    link.click();

                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        }
    }
};
</script>
